// extracted by mini-css-extract-plugin
module.exports = {"modal":"MetamaskModal_modal__2snqh","infoWrapper":"MetamaskModal_infoWrapper__2kECM","subheader":"MetamaskModal_subheader__1EanI","okButton":"MetamaskModal_okButton__1KzCi"};